// 请求相关

export enum NetworkTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
}

// 冻结账号相关接口
export const FREEZE_CMDID = [
  '314501',
  '7242031',
  '621116',
  '396101',
  '420029',
  '724209',
  '621112',
  '377003',
  '7242026',
  '390004',
  '3740012',
  '321543',
  '310400',
  '325308',
];

export const WITHDRAWAL_CMDID = ['325308'];

export const NO_CANCEL_CMDID = ['370730']; // 不需要取消的请求集合
